import { onlyIscriptionCourses } from "../utils/app_manage";

export const API_URL = process.env.REACT_APP_API_URL;
export const API_URL_MICRO = process.env.REACT_APP_URL_MICRO;
export const API_URL_INVOICE = process.env.REACT_APP_URL_INVOICE;
export const API_URL_MICRO_BOLETA = process.env.REACT_APP_URL_MICRO_BOLETA;
export const INT_KEY = process.env.REACT_APP_INT_KEY;
export const USERNAME = process.env.REACT_APP_USER;
export const PASSWORD = process.env.REACT_APP_PASSWORD;
export const appType = process.env.REACT_APP_APP_Type;
export const INSCRIPTION_FULL=process.env.REACT_APP_INSCRIPTION_FULL
export const REACT_APP_CAN_GET_ALL_PAY=process.env.REACT_APP_CAN_GET_ALL_PAY
export const APP_INSCRIPCION_FULL = process.env.REACT_APP_APP_INSCRIPCION_FULL;
export const API_GET_AMOUNT_PAY = `${process.env.REACT_APP_GET_MATRICULA}/boleta/get-amount-pay`
export const API_APLICA_BONIFICACION = `${process.env.REACT_APP_GET_MATRICULA}/boleta/aplica-bonificacion`
export const VERSION = process.env.REACT_APP_VERSION ?? "1.0.0";
export const YEARS = ["2027"];

const IS_DEVELOP = String(process.env.REACT_APP_DEVELOP_MODE).toLowerCase() === 'true';
export const PRODUCTION = !IS_DEVELOP;
export const SECTOR_CODE= process.env.REACT_APP_SECTOR;
export const AUTH_URL = {
  // GENERATE_TOKEN: `${API_URL}auth/anon`,
  GENERATE_TOKEN: `${API_URL_MICRO_BOLETA}jwt/index.php?int_key=${INT_KEY}&int_name=boleta`,
  SIGNUP: `${API_URL_MICRO}admisiones/registro`,
};
export const SERVICES_URL_MICRO = {
  CARRERS: {
    SECTOR:`${API_URL_MICRO}sectores/`,
    LIST: `${API_URL_MICRO}ingresos/${YEARS[0]}/`,
  },
  PLACES: {
    LIST: `${API_URL_MICRO}ingresos/${YEARS[0]}/`,
  },
};

export const SERVICES_URL = {
  DOCUMENT_TYPES: {
    //LIST: `${API_URL}mi-perfil/lovs/tipo-documentos?tdocu=0&ndocu=1`
    LIST: `${API_URL_MICRO}lovs/tipo-documentos?tdocu=0&ndocu=1`,
  },
  PROFILE: {
    GET: `${API_URL_MICRO}admisiones/perfil`,
  },
  CARRERS: {
    LIST: `${API_URL}registro-inicial/lovs/carrera`,
  },
  PLACES: {
    LIST: `${API_URL}registro-inicial/lovs/lugares`,
  },
  MODES: {
    LIST: `${API_URL_MICRO}ingresos/lovs/modos`,
  },
  SECTOR: {
    LIST: `${API_URL_MICRO}ingresos/lovs/sectores`,
  },
  CHECKBOXES: {
    ENROLLMENT: `${API_URL_MICRO}admisiones/inscripcion-habilitada-carrera`,
    NOTIFICATION: `${API_URL_MICRO}admisiones/terminos_y_condiciones/inscripcion/obtener_notificacion`,
  },
  INVOICE: {
    APPLICATION_ADMISSION: `${API_URL_MICRO}admisiones/solicitud-ingreso`,
    ACEPT: `${API_URL}admisiones/terminos_y_condiciones/inscripcion/aceptar`,
    IS_MASTER: `${API_URL}admisiones/existe-maestro`,
    CARRERS_CUT: `${API_URL}admisiones/carrerasXCohorte`,
    INVOICE_2CUT: `${API_URL}admisiones/boleta-2cohorte`,
    DATA: `${API_URL_MICRO}boleta/datos-boleta`,
    SEND_MAIL: `${API_URL_INVOICE}boleta/enviar_mail`,
    INOVICE: `${API_URL_INVOICE}boleta`,
    INSERT_CONCEPT: `${API_URL_INVOICE}boleta/insertar_concepto`,
    INVOICE_TRADITIONAl: `${API_URL_INVOICE}boleta/boleta_tradicional`,
  },
};


export const SOCIAL_URL = {
  facebook: "https://www.facebook.com/Ucasal",
  instagram: "https://www.instagram.com/ucasal/",
  tiktok: "https://www.tiktok.com/@ucasal",
  youtube: "https://www.youtube.com/UCASAL",
  whatsapp:
    "https://api.whatsapp.com/send?phone=543875081925&text=Hola!%20Quiero%20saber%20m%C3%A1s%20sobre...",
  linkedin: "https://www.linkedin.com/school/universidad-cat-lica-de-salta/",
};

export const SELECT_PLACEHOLDERS = {
  year: "Seleccione el año",
  carrer: `Seleccione la ${onlyIscriptionCourses() ? "capacitación" : "carrera"} a estudiar`,
  place: "Selecciona el lugar donde vas a estudiar",
  mode: "Seleccione la modalidad de estudio",
  sector: "Seleccione el sector de estudio",
};

export const PAYMENT_METHOD = {
  online: {
    id: 1,
    display: "Pago online",
  },
  email: {
    id: 2,
    display: "Recibir boleta de pago",
  },
};

